<template>
    <div>
        <el-drawer title="特殊发票内容" :visible.sync="drawer" size="40%" >
            <div class="wapper">
                <div class="query-wapper">
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-input placeholder="请输入特殊发票内容" v-model.trim="searchInfo.invoiceContent"></el-input>
                        </el-col>
                        <el-col :span="10">
                            <Select :type="'InvoiceSpecialStateEnum'" ref="select" :placeholder="'请选择特殊发票状态'"  @change="change"></Select>
                        </el-col>
                    </el-row>
                    <div class="button-wapper">
                        <el-button plain size='mini' v-auth="'view'" @click="getInfoList()">查询</el-button>
                        <el-button plain size='mini' @click="reset">重置</el-button>
                        <el-button plain size='mini' @click="add" v-auth="'edit'" type="primary">新增</el-button>
                    </div>
                </div>
            </div>

            <div class="table">
                <el-table :data="tableData" :border="true">
                    <el-table-column fixed prop="invoiceSpecialCode" label="编号" width="150">
                    </el-table-column>
                    <el-table-column prop="invoiceContent" label="特殊发票内容" >
                    </el-table-column>
                    <el-table-column prop="stateName" label="状态" width="120">
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">

                            <el-button type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination  @current-change="handleCurrentChange" class="pagination"
                    :current-page.sync="query.pageIndex" :page-size="query.pageSize" layout="prev, pager, next, jumper" :total="query.total">
                </el-pagination>
            </div>
        </el-drawer>
        <el-dialog :title="info.id == null ? '添加特殊发票内容' : '编辑特殊发票内容'" :visible.sync="dialogVisible" v-if="dialogVisible" width="650px">
            <div class="tips">说明：添加特殊发票内容后，销售提交的开票申请中如果触发该内容，将需财务负责人审批！</div>
            <div class="content-wapper" v-if="info != null">

                <el-form :model="info" :rules="rules" ref="ruleForm" label-width="150px" style="width:500px;">
                    <el-form-item label="特殊发票内容名称" prop="invoiceContent">
                        <el-input placeholder="请输入特殊发票内容名称" v-model.trim="info.invoiceContent"></el-input>
                    </el-form-item>

                    <el-form-item label="特殊发票内容状态" prop="state">
                        <el-select v-model="info.state" placeholder="请选择特殊发票内容状态">
                            <el-option v-for="item in state" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="button-wapper">
                    <el-button size="small" @click="dialogVisible = false">取消</el-button>
                    <el-button size="small" type="primary" @click="submit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import _invoiceContent from '@/service/invoice-content-service'
import Select from '@/views/common/Select' 
export default {
    data() {
        return {
            searchInfo: {},
            info: {},
            dialogVisible: false,
            invoiceContent: '',
            drawer: false,
            formInline: {
                user: '',
                region: ''
            },
            query: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            state: [{
                value: 1,
                label: '已开启'
            }, {
                value: 0,
                label: '已关闭'
            }],
            tableData: [],
            rules: {
                invoiceContent: [
                    { required: true, message: '请输入特殊发票内容名称', trigger: 'blur' }
                ],
                state: [
                    { required: true, message: '请选择特殊发票内容状态', trigger: ['change'] }
                ],
            },
            // direction: {},
            // handleClose:{},
            // handleSizeChange:{}
        }
    },
    components: {
        Select,
        
    },
    methods: {
        show() {

            this.drawer = true
            this.getInfoList()
        },
        change(e) {
           
            this.searchInfo.state = e
        },
        handleCurrentChange(e) {
            this.query.pageIndex = e
            this.getInfoList()
        },
        getInfoList() {
            let data ={...this.searchInfo,pageIndex:this.query.pageIndex} 
            _invoiceContent.getPageList(
                data,
                (response, total) => {
                    // 请求成功
                    this.tableData = response
                    this.query.total = total
                })
        },
        add() {
            this.info={}
            this.dialogVisible = true
        },
        edit(id) {
            let index = this.tableData.findIndex(item => {
                return item.id==id
            })
            this.info = this.tableData[index]
            
            this.dialogVisible = true
        },
        reset() {
            this.searchInfo = {}
            this.query.pageIndex = 1
            this.tableData = []
            this.$refs.select.reset()
            this.getInfoList()
        },
        submit() {
            let data = this.info

            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                        return false
                }
                _invoiceContent.createOrUpdate(
                data,
                (response) => {
                    this.$notify({
                    message:this.info.id?'编辑成功':'添加成功',
                    type: 'success'
                    })
                    this.getInfoList()
                    this.dialogVisible = false
                }, response => {
                    this.$notify({
                    message: response,
                    type: 'error'
                    })
                    
                })
            })

           
           
        }

    }
}

</script>
<style scoped>
.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.query-wapper {
    margin: 15px;
    padding: 15px;
    border: 1px solid #d6dbe5;
    position: relative;
    background: #fff;
}

.query-wapper::after {
    position: absolute;
    content: "筛选条件";
    top: -9px;
    color: #909399;
    background-color: #fbfbfb;
}

.content-wapper {
    padding: 0 15px;
    padding-bottom: 30px;
}

.button-wapper {
    text-align: center;
    margin-top: 10px;
}

.el-row {
    margin-bottom: 15px;
}



.table {
    padding: 0 30px;
   
}

.pagination {
    margin-top: 10px;
}

.tips {
    height: 50px;
    color: red;
    line-height: 50px;
    padding-left: 20px;
    margin-bottom: 20px;
    background-color: rgb(246, 208, 41);
}
/deep/ .el-table__fixed {
    height: 100% !important; 
}

</style>